import { AppInfo, GlobalConfig, EffectiveSettings } from '@/types/api';
import { getApiBaseUrl, handleResponse, getApiPort } from './client';

const DAEMON_BASE_URL = 'http://localhost:9998';

export async function checkBackendHealth(): Promise<{ status: string }> {
    const response = await fetch(`${getApiBaseUrl()}/health`);
    return handleResponse<{ status: string }>(response);
}

// App info
export async function getAppInfo(): Promise<AppInfo> {
    const response = await fetch(`${getApiBaseUrl()}/info`);
    return handleResponse<AppInfo>(response);
}

export async function getWebsocketEnabled(): Promise<{ enabled: boolean }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/websocket-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setWebsocketEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/websocket-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getAutoContextFetchEnabled(): Promise<{
    enabled: boolean;
}> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/auto-context-fetch-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setAutoContextFetchEnabled(
    enabled: boolean,
): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/auto-context-fetch-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getYoloModeEnabled(): Promise<{ enabled: boolean }> {    const response = await fetch(
        `${getApiBaseUrl()}/application-state/yolo-mode-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setYoloModeEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/yolo-mode-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getTheme(): Promise<{ theme: string }> {
    const response = await fetch(`${getApiBaseUrl()}/application-state/theme`);
    return handleResponse<{ theme: string }>(response);
}

export async function setTheme(theme: string): Promise<void> {
    const response = await fetch(`${getApiBaseUrl()}/application-state/theme`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ theme }),
    });
    await handleResponse<void>(response);
}

export async function getContextTokenLimit(): Promise<{ limit: number }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/context-token-limit`,
    );
    return handleResponse<{ limit: number }>(response);
}

export async function setContextTokenLimit(limit: number): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/context-token-limit`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ limit }),
        },
    );
    await handleResponse<void>(response);
}

export async function getExecutionStrategy(): Promise<{ strategy: string }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/execution-strategy`,
    );
    return handleResponse<{ strategy: string }>(response);
}

export async function setExecutionStrategy(strategy: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/execution-strategy`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ strategy }),
        },
    );
    await handleResponse<void>(response);
}

export async function getOpenrouterConfig(): Promise<{ apiKey: string | null }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/openrouter-config`,
    );
    return handleResponse<{ apiKey: string | null }>(response);
}

export async function setOpenrouterConfig(apiKey: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/openrouter-config`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ apiKey }),
        },
    );
    await handleResponse<void>(response);
}

export async function getZaiConfig(): Promise<{ apiKey: string | null }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/zai-config`,
    );
    return handleResponse<{ apiKey: string | null }>(response);
}
export async function setZaiConfig(apiKey: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/zai-config`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ apiKey }),
        },
    );
    await handleResponse<void>(response);
}



export async function getAlibabaConfig(): Promise<{ apiKey: string | null }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/alibaba-config`,
    );
    return handleResponse<{ apiKey: string | null }>(response);
}

export async function setAlibabaConfig(apiKey: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/alibaba-config`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ apiKey }),
        },
    );
    await handleResponse<void>(response);
}

export async function getOllamaConfig(): Promise<{ apiKey: string | null }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/ollama-config`,
    );
    return handleResponse<{ apiKey: string | null }>(response);
}

export async function setOllamaConfig(apiKey: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/ollama-config`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ apiKey }),
        },
    );
    await handleResponse<void>(response);
}

export async function getOpenaiConfig(): Promise<{ apiKey: string | null; baseUrl: string | null; apiKeySource: string; baseUrlSource: string }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/openai-config`,
    );
    return handleResponse<{ apiKey: string | null; baseUrl: string | null; apiKeySource: string; baseUrlSource: string }>(response);
}

export async function setOpenaiConfig(apiKey?: string, baseUrl?: string): Promise<void> {
    const body: Record<string, string> = {};
    if (apiKey !== undefined) body.apiKey = apiKey;
    if (baseUrl !== undefined) body.baseUrl = baseUrl;
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/openai-config`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        },
    );
    await handleResponse<void>(response);
}

export async function getStreamingEnabled(): Promise<{ enabled: boolean }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/streaming-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setStreamingEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/streaming-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getToolsEnabled(): Promise<{ enabled: boolean }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/tools-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setToolsEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/tools-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getYoloModeMessage(): Promise<{ message: string }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/yolo-mode-message`,
    );
    return handleResponse<{ message: string }>(response);
}

export async function setYoloModeMessage(message: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/yolo-mode-message`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message }),
        },
    );
    await handleResponse<void>(response);
}

export async function getSyntaxValidationEnabled(): Promise<{
    enabled: boolean;
}> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/syntax-validation-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setSyntaxValidationEnabled(
    enabled: boolean,
): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/syntax-validation-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}
export async function getFollowupTokenLimit(): Promise<{
    limit: number;
}> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/followup-token-limit`,
    );
    return handleResponse<{ limit: number }>(response);
}

export async function setFollowupTokenLimit(
    limit: number,
): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/followup-token-limit`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ limit }),
        },
    );
    await handleResponse<void>(response);
}

export async function getHistoryCompressionEnabled(): Promise<{
    enabled: boolean;
}> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/history-compression-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setHistoryCompressionEnabled(
    enabled: boolean,
): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/history-compression-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}
export async function getLlmRetryEnabled(): Promise<{ enabled: boolean }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/llm-retry-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setLlmRetryEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/llm-retry-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export async function getLlmRetryMaxAttempts(): Promise<{ attempts: number }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/llm-retry-max-attempts`,
    );
    return handleResponse<{ attempts: number }>(response);
}

export async function setLlmRetryMaxAttempts(attempts: number): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/llm-retry-max-attempts`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ attempts }),
        },
    );
    await handleResponse<void>(response);
}

export async function getNotificationsEnabled(): Promise<{ enabled: boolean }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/notifications-enabled`,
    );
    return handleResponse<{ enabled: boolean }>(response);
}

export async function setNotificationsEnabled(enabled: boolean): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/notifications-enabled`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ enabled }),
        },
    );
    await handleResponse<void>(response);
}

export interface LlmModel {
    id: string;
    name: string;
    provider: 'openrouter' | 'zai' | 'alibaba' | 'ollama' | 'openai' | 'custom';
}

export async function getLlmModels(): Promise<{ models: LlmModel[] }> {
    const response = await fetch(`${getApiBaseUrl()}/llm-provider/models`);
    return handleResponse<{ models: LlmModel[] }>(response);
}

export async function getRecentModels(): Promise<{ models: string[] }> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/recent-models`,
    );
    return handleResponse<{ models: string[] }>(response);
}

export async function setAsActiveUi(): Promise<void> {
    const port = getApiPort();
    if (!port) {
        console.warn(
            'Could determine backend port. Skipping registration with daemon.',
        );
        return;
    }

    try {
        const response = await fetch(
            `${DAEMON_BASE_URL}/registry/set-active-port`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ port }),
            },
        );
        if (!response.ok) {
            let errorData;
            try {
                errorData = await response.json();
            } catch {
                // ignore
            }
            console.error(
                'Failed to set active UI with daemon',
                response.status,
                errorData,
            );
        }
    } catch (e) {
        console.error(
            'Failed to communicate with Repoburg Daemon to set active UI.',
            e,
        );
    }
}

// ===== Global Config API =====

export async function getGlobalConfig(): Promise<GlobalConfig> {
    const response = await fetch(`${getApiBaseUrl()}/global-config`);
    return handleResponse<GlobalConfig>(response);
}

export async function updateGlobalConfig(config: Partial<GlobalConfig>): Promise<GlobalConfig> {
    const response = await fetch(`${getApiBaseUrl()}/global-config`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(config),
    });
    return handleResponse<GlobalConfig>(response);
}

// ===== Effective Settings API =====

export async function getEffectiveSettings(): Promise<EffectiveSettings> {
    const response = await fetch(`${getApiBaseUrl()}/application-state/effective`);
    return handleResponse<EffectiveSettings>(response);
}

export async function getProjectOverrides(): Promise<{ overrides: Record<string, string> }> {
    const response = await fetch(`${getApiBaseUrl()}/application-state/overrides`);
    return handleResponse<{ overrides: Record<string, string> }>(response);
}

export async function clearProjectOverride(key: string): Promise<void> {
    const response = await fetch(
        `${getApiBaseUrl()}/application-state/override/${key}`,
        {
            method: 'DELETE',
        },
    );
    await handleResponse<void>(response);
}